import { render } from "./FilterGallery.vue?vue&type=template&id=36d98437&scoped=true"
import script from "./FilterGallery.vue?vue&type=script&lang=js"
export * from "./FilterGallery.vue?vue&type=script&lang=js"

import "./FilterGallery.vue?vue&type=style&index=0&id=36d98437&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36d98437"

export default script